import React, { useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CoverageDetailsMobile } from './CoverageDetailsMobile';
import { CoverageDetailsDesktop } from './CoverageDetailsDesktop';
import useWidth from '../../../../../hooks/useWidth';
import CoveragesDetailsConfig from './CoveragesDetailsConfig';
import { Check } from '@gje/icons';

export const CoverageDetails = ({
    coverages,
    setSelectedCoverage,
    paymentTerm
}) => {
    const width = useWidth();
    const DESKTOP_WIDTH_THRESHOLD = 650;
    const [selectedIndex, setSelectedIndex] = useState(1);

    const basicProps = {
        coverages: coverages,
        coveragesConfig: CoveragesDetailsConfig,
        selectedIndex: selectedIndex,
        setSelectedCoverage: setSelectedCoverage,
        setSelectedIndex: setSelectedIndex,
        paymentTerm: paymentTerm
    };

    if (width < DESKTOP_WIDTH_THRESHOLD) {
        return <CoverageDetailsMobile {...basicProps} />;
    } else {
        return <CoverageDetailsDesktop {...basicProps} />;
    }
};

export const resolveQuestion = value => {
    if (value === 'V') {
        return <Check size={35} />;
    } else if (value !== null && value !== 'V') {
        return value;
    } else {
        return '';
    }
};

export const getPrice = (id, coverages) => {
    return coverages.find(value => value.coverageProduct == id).premium;
};
